import React, { lazy, Suspense } from 'react';
import { Loader } from '../loader/loader.js';
import { QRCodeProperties } from './qrcode-types.js';
// @ts-expect-error QRCode type declaration is incomplete
const QRCodeReact = lazy(() => import('qrcode.react'));
function QRCode(props) {
    const { backgroundColor = QRCodeProperties.backgroundColor.defaultValue, errorLevel = QRCodeProperties.errorLevel.defaultValue, foregroundColor = QRCodeProperties.foregroundColor.defaultValue, includeMargin = QRCodeProperties.includeMargin.defaultValue, size = QRCodeProperties.size.defaultValue, value = QRCodeProperties.value.defaultValue, } = props;
    return (React.createElement(Suspense, { fallback: React.createElement(Loader, null) },
        React.createElement(QRCodeReact, { bgColor: backgroundColor, fgColor: foregroundColor, includeMargin: includeMargin, level: errorLevel, size: Number(size), value: value })));
}
export { QRCode, };
export default QRCode;
//# sourceMappingURL=qrcode.js.map